import Swal from 'sweetalert2';

export const notifyInfo = (title) => {
  Swal.fire({
    title,
    icon: 'info',
    showCancelButton: false,
    confirmButtonText: 'Ok',
    buttonsStyling: false,
    customClass: {
      confirmButton:
        'w-[100px] h-[40px] payer rounded-[10px] geomanistBold text-[1.4rem] p-4',
    },
  });
};
export const notifyError = (title, text, callBack, timer) => {
  Swal.fire({
    title,
    text,
    icon: 'error',
    closeButtonHtml: 'X',
    confirmButtonColor: '#FFD700',
    confirmButtonText: 'Ok',
    buttonsStyling: false,
    timer: timer ?? null,
    customClass: {
      title: 'title-class',
      confirmButton:
        'bg-yellow-400 payer w-[100px] text-center h-16 geomanistBold text-[1.7rem] rounded-md',
    },
  }).then(() => {
    if (callBack) {
      callBack();
    }
  });
};

export const notifyWarning = (title, text, buttonLabel, callBack) => {
  Swal.fire({
    title,
    text,
    icon: 'warning',
    showConfirmButton: true,
    confirmButtonText: buttonLabel || 'Fermer',
    buttonsStyling: false,
    customClass: {
      confirmButton:
        'bg-[#16c72e] p-4 !rounded-xl payer w-full geomanistBold text-[1.5rem]',
    },
  }).then(() => {
    if (callBack && typeof callBack === 'function') {
      callBack();
    }
  });
};

export const confirmWarning = (title, text, confirmText, callBack) => {
  Swal.fire({
    title,
    text,
    icon: 'warning',
    showConfirmButton: true,
    showLoaderOnConfirm: true,
    showCancelButton: true,
    cancelButtonText: 'Fermer',
    confirmButtonText: confirmText || 'Ok',
    buttonsStyling: false,
    customClass: {
      confirmButton:
        'bg-[#16c72e] p-4 !rounded-md payer w-[90%] geomanistBold text-[1.5rem] ',
      cancelButton:
        'bg-[#807f7f] p-4 rounded-md text-white w-[90%] geomanistBold my-4 text-[1.5rem] ',
    },
  }).then((result) => {
    if (result.isConfirmed && callBack) {
      callBack(result);
    }
  });
};

export const notifySuccess = (title, text, buttonLabel, callBack) => {
  Swal.fire({
    title,
    text,
    icon: 'success',
    showConfirmButton: true,
    confirmButtonText: buttonLabel || 'Ok',
    buttonsStyling: false,
    customClass: {
      confirmButton:
        'bg-[#16c72e] p-4 !rounded-xl payer w-full geomanistBold text-[1.5rem]',
    },
  }).then(() => {
    if (callBack) {
      callBack();
    }
  });
};

export const notifyConfirmation = (
  title,
  text,
  confirmLabel,
  cancelLabel,
  callBack,
  icon,
) => {
  Swal.fire({
    title,
    text,
    icon,
    showConfirmButton: true,
    showCancelButton: true,
    confirmButtonText: confirmLabel,
    cancelButtonText: cancelLabel,
    buttonsStyling: false,

    customClass: {
      confirmButton: 'notify-button notify-button--confirm',
      cancelButton: 'notify-button notify-button--cancel',
      htmlContainer: 'notify-label',
    },
  }).then((result) => {
    if (result.isConfirmed && callBack) {
      callBack();
    }
  });
};

export const notifyDoubleCallback = (
  title,
  text,
  icon,
  confirmLabel,
  cancelLabel,
  titleConfirm,
  textConfirm,
  confirmCallback,
  titleCancel,
  textCancel,
  cancelCallback,
) => {
  const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      confirmButton:
        'bg-[#16c72e] p-4 !rounded-md payer w-[90%] geomanistBold text-[1.5rem]',
      cancelButton:
        'bg-[#807f7f] p-4 rounded-md text-white w-[90%] geomanistBold my-4 text-[1.5rem] ',
      htmlContainer: 'notify-label',
    },
    buttonsStyling: false,
  });
  const swalWithBootstrapButtons2 = Swal.mixin({
    customClass: {
      confirmButton:
        'bg-[#16c72e] p-4 !rounded-md payer w-full geomanistBold text-[1.5rem]',
      cancelButton:
        'bg-[#807f7f] p-4 rounded-md text-white w-[90%] geomanistBold my-4 text-[1.5rem] ',
      htmlContainer: 'notify-label',
    },
    buttonsStyling: false,
  });
  swalWithBootstrapButtons
    .fire({
      allowOutsideClick: false,
      title: title,
      text: text,
      icon: icon,
      showCancelButton: true,
      confirmButtonText: confirmLabel,
      cancelButtonText: cancelLabel,
      reverseButtons: true,
    })
    .then((result) => {
      if (result.isConfirmed && confirmCallback) {
        confirmCallback();
        swalWithBootstrapButtons2.fire({
          title: titleConfirm,
          text: textConfirm,
          icon: 'success',
        });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        cancelCallback();
        swalWithBootstrapButtons2.fire({
          title: titleCancel,
          text: textCancel,
          icon: 'info',
        });
      }
    });
};

export const notifyFromErrorConfig = (errorConfig) => {
  if (errorConfig.type === 'warning') {
    if (errorConfig.action) {
      notifyWarning(
        errorConfig.title,
        errorConfig.message,
        errorConfig.action.text,
        errorConfig.action.callback,
      );
    } else {
      notifyWarning(errorConfig.title, errorConfig.message);
    }
  } else {
    notifyError(errorConfig.title, errorConfig.message);
  }
};

export const notifyDebugForm = (axiosInstance, user, order, dispatch) => {
  return new Promise((resolve, reject) => {
    Swal.fire({
      title: 'Demander un accès',
      input: 'text',
      inputLabel: "Code d'accès",
      inputPlaceholder: 'Entrez votre code...',
      inputAttributes: {
        autocapitalize: 'off',
      },
      showCancelButton: true,
      confirmButtonText: 'Activer',
      allowOutsideClick: false,
      cancelButtonText: 'Annuler',
      showLoaderOnConfirm: true,
      preConfirm: async (code) => {
        if (!code) {
          return Swal.showValidationMessage('Entrez un code');
        }

        const orderId =
          order?._id || JSON.parse(localStorage.getItem('cartItems'))?._id;

        if (!orderId) {
          return Swal.showValidationMessage('Commande non définie');
        }

        try {
          const response = await axiosInstance.put(
            `/orders/${orderId}/update-debug`,
            {
              userId: user?._id || 'anonymous',
              password: code,
              timestamp: new Date().toISOString(),
            },
          );
          return response?.data;
        } catch (error) {
          const errorMessage =
            error?.response?.data?.message ||
            error?.message ||
            'Erreur inconnue';
          return Swal.showValidationMessage(`Erreur: ${errorMessage}`);
        }
      },
    })
      .then((result) => {
        if (result.isConfirmed && result.value) {
          Swal.fire({
            title: 'Debug activé !',
            text: 'Le mode debug est maintenant actif',
            icon: 'success',
          });

          dispatch({ type: 'CART_INFO_SUCCESS', payload: result.value });

          const existingCartItems = JSON.parse(
            localStorage.getItem('cartItems') || '{}',
          );
          const updatedCartItems = { ...existingCartItems, ...result.value };
          localStorage.setItem('cartItems', JSON.stringify(updatedCartItems));

          resolve(result.value);
        } else {
          resolve(null);
        }
      })
      .catch((error) => {
        console.error('Erreur dans notifyDebugForm:', error);
        reject(error);
      });
  });
};
